export default __webpack_public_path__ + "static/media/image_2.275645f5.png";